import React from "react";

const Line = () => {
  return (
    <div className="bg-mediumBrown w-full h-[1px] rounded-sm my-4 opacity-30"></div>
  )
}
export default Line;